import { useEffect, useState } from 'react'

import {
  RightDrawer,
  DrawerActions,
  DrawerContainer,
  DrawerHeader,
  DrawerContent,
} from '../../../components/right-drawer'
import FileUploader from '../../../components/file-uploader'
import { useGetSignedUrlMutation } from '../slice'
import { TAGS } from '../../../constants/tags'

const AddImportDrawer = ({ drawerOpen, setDrawerOpen }) => {
  const [files, setFiles] = useState([])
  const [isUploading, setIsUploading] = useState(false)

  useEffect(() => {
    if (!drawerOpen && !isUploading) setFiles([])
  }, [drawerOpen, isUploading])

  const [getSignedUrl] = useGetSignedUrlMutation()

  return (
    <RightDrawer showDrawer={drawerOpen} setShowDrawer={setDrawerOpen} anchor="right">
      <DrawerContainer>
        <DrawerHeader title="Import Prospects" setShowDrawer={setDrawerOpen} />
        <DrawerContent>
          <FileUploader
            name="importFile"
            files={files}
            setFiles={setFiles}
            signedUrlMutation={getSignedUrl}
            trigger={setIsUploading}
            invalidateTags={[TAGS.IMPORTS]}
          />
        </DrawerContent>
        <DrawerActions
          buttons={[
            {
              action: () => {
                setDrawerOpen(false)
              },
              label: 'Close',
              variant: 'contained',
              loading: isUploading,
            },
          ]}
        />
      </DrawerContainer>
    </RightDrawer>
  )
}

export default AddImportDrawer
